import { useCallback, useEffect, useRef, useState } from 'react';

export function useResponsiveWidth() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [excludedColsInOtherDocs, setExcludedColsInOtherDocs] = useState<string[]>(['all', 'kid', 'factsheet']);

  const adjustWidth = useCallback(() => {
    const elem = containerRef.current?.parentElement;
    if (!elem) {
      return;
    }

    const w = elem.offsetWidth;
    setExcludedColsInOtherDocs(w < 820 ? ['all'] : ['all', 'kid', 'factsheet']);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', adjustWidth);
    adjustWidth();
    return () => window.removeEventListener('resize', adjustWidth);
  }, [adjustWidth]);

  return { containerRef, excludedColsInOtherDocs, adjustWidth };
}
